module.exports = __webpack_public_path__ + "static/media/timeline-active.f062c78b.svg";